export class ProcessInstance {
    Id: string;
    DefinitionId: string;
    BusinessKey: string;
    WorkflowId: number;
    WorkflowName: string;
    StartTime: Date;
    EndTime: Date;
    State: string;
}